import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AgeService {
  constructor() { }

  public computeAge(birthDate: Date, calcDate: Date): number {
    // Birth Date should be before Calc Date
    if (birthDate.getFullYear() > calcDate.getFullYear()) {
      return -1;
    }
    if (calcDate.getMonth() > birthDate.getMonth()) {
      // His birthday has already passed
      return this.dateDiff(calcDate, birthDate, 'year');
    } else if (calcDate.getMonth() < birthDate.getMonth()) {
      // His birthday is still coming for the year
      return (this.dateDiff(calcDate, birthDate, 'year') - 1)
    } else if (calcDate.getMonth() == birthDate.getMonth()) {
      if (calcDate.getDate() >= birthDate.getDate()) {
        // He has had his birthday
        return (this.dateDiff(calcDate, birthDate, 'year'));
      } else if (calcDate.getDate() < birthDate.getDate()) {
        // Birthday is tomorrow
        return (this.dateDiff(calcDate, birthDate, 'year') - 1);
      }
    }

    return -1;
  }

  private dateDiff(date1: Date, date2: Date, interval: string): number {
    // Do a switch on the interval and return result
    switch (interval) {
      case "year":
        return (date1.getFullYear() - date2.getFullYear());
      case "month":
        return (date1.getMonth() - date2.getMonth());
      case "day":
        return (date1.getDate() - date1.getDate());
      case "weekday":
        return (date1.getDay() - date2.getDate());
      case "hour":
        return (date1.getHours() - date2.getHours());
      default:
        return 0
    }
  };
}
